import React, { useEffect, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import WebLayout from 'layout/WebLayout';

import Loading from 'components/Loading';

import buildMatch from 'utils/buildMatch';

const Share = lazy(() => import('modules/Web/container/Share'));
const Preview = lazy(() => import('modules/Web/container/Preview'));

const SharePage = ({ matchpath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const match = buildMatch(location, params, matchpath);

  const {
    params: { projectID, pageID, versionID },
  } = match;

  useEffect(() => {
    if (
      (location.pathname.startsWith('/share') && !projectID) ||
      (location.pathname.startsWith('/preview') &&
        !projectID &&
        !pageID &&
        !versionID)
    )
      navigate('/');
  }, [projectID, pageID, versionID, navigate, location]);

  return (
    <WebLayout match={match}>
      {location.pathname.startsWith('/share') && (
        <Suspense fallback={<Loading />}>
          <Share match={match} projectID={projectID} />
        </Suspense>
      )}
      {location.pathname.startsWith('/preview') && (
        <Suspense fallback={<Loading />}>
          <Preview
            match={match}
            projectID={projectID}
            pageID={pageID}
            versionID={versionID}
          />
        </Suspense>
      )}
    </WebLayout>
  );
};

SharePage.propTypes = {
  matchpath: PropTypes.string,
};

export default SharePage;
